







































































































































































import { Component, Mixins, Ref } from "vue-property-decorator";
import ChangeContractDialog from "@/components/contractmanagement/ChangeContractDialog.vue";
import OfficeStaffChangeDialog from "@/components/contractmanagement/OfficeStaffChangeDialog.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import PortalOfficeSelector from "@/components/portal/PortalOfficeSelector.vue";
import JobsearchRecruiteeSelector from "@/components/jobsearch/JobsearchRecruiteeSelector.vue";
import OfficeInfo from "@/components/contractreception/OfficeInfo.vue";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import OutputExcelDialog from "@/components/contractmanagement/OutputExcelDialog.vue";
import InputExcelDialog from "@/components/contractmanagement/InputExcelDialog.vue";
import TrumbowygEditor from "@/components/trumbowyg/TrumbowygEditor.vue";
import TextDayChangePicker from "#/components/TextDayChangePicker.vue";
import RulesMixin from "#/mixins/rulesMixin";
import { VForm } from "@/types";

import {
  PORTAL_JOBSEARCH_OFFICIAL_ANNOUNCEMENT_DESTINATION,
  PORTAL_OFFICIAL_ANNOUNCEMENT_STATUS,
} from "@/consts/portal";

import {
  PortalOfficialAnnouncement,
  PortalOfficialAnnouncementTargetOffice,
  PortalOfficialAnnouncementTargetRecruitee,
  DEFAULT_OFFICIAL_ANNOUNCEMENT,
  PortalOffice,
  PortalJobsearchRecruitee,
} from "@/model/portal";

import { PortalOfficialAnnouncementForm } from "@/components/portal/types";
import { PortalSearchParams } from "@/components/portal/PortalOfficeSearchBox.vue";

@Component({
  components: {
    ChangeContractDialog,
    OfficeInfo,
    AppAuthButton,
    OfficeStaffChangeDialog,
    OutputExcelDialog,
    InputExcelDialog,
    TrumbowygEditor,
    TextDayChangePicker,
    PortalOfficeSelector,
    JobsearchRecruiteeSelector,
  },
})
export default class extends Mixins(AxiosMixin, UtilMixin, RulesMixin) {
  @Ref("inputForm") private readonly inputForm!: VForm;
  /** 初回ロード完了フラグ */
  private initLoadingDone = false;
  private announcement: PortalOfficialAnnouncement = {
    ...DEFAULT_OFFICIAL_ANNOUNCEMENT,
  };
  private showSaveCompleteBar = false;
  private offices: PortalOffice[] = [];
  private recruitees: PortalJobsearchRecruitee[] = [];
  private targetOffices: PortalOffice[] = [];
  private targetRecruitees: PortalJobsearchRecruitee[] = [];

  private PORTAL_JOBSEARCH_OFFICIAL_ANNOUNCEMENT_DESTINATION =
    PORTAL_JOBSEARCH_OFFICIAL_ANNOUNCEMENT_DESTINATION;
  private PORTAL_OFFICIAL_ANNOUNCEMENT_STATUS =
    PORTAL_OFFICIAL_ANNOUNCEMENT_STATUS;

  public async created() {
    await this.fetchItem(Number(this.$route.params.id));
    await this.fetchList();

    if (this.announcement.id != 0) {
      this.targetOffices = this.announcement.target_portal_offices
        ? (this.announcement.target_portal_offices
            .map((to: PortalOfficialAnnouncementTargetOffice) =>
              this.offices.find((o) => o.id === to.portal_office_id)
            )
            .filter(Boolean) as PortalOffice[])
        : [];
      this.targetRecruitees = this.announcement.target_recruitees
        ? (this.announcement.target_recruitees
            .map((to: PortalOfficialAnnouncementTargetRecruitee) =>
              this.recruitees.find((o) => o.id === to.jobsearch_recruitee_id)
            )
            .filter(Boolean) as PortalJobsearchRecruitee[])
        : [];
    }

    this.initLoadingDone = true;
  }

  /** 運営からのお知らせ */
  private async fetchItem(id: number) {
    if (id == 0) {
      return;
    }
    return new Promise((resolve) => {
      this.postJsonCheck(
        window.base_url + "/api/admin/portal_official_announcement/get",
        {
          service: 1,
          official_announcement_id: id,
        },
        (res) => {
          this.announcement = res.data.official_announcement;
          resolve(0);
        }
      );
    });
  }

  /** 事務所取得 */
  private async fetchList() {
    return Promise.all([
      new Promise((resolve) => {
        const searchObj: PortalSearchParams = {
          is_carelogood: true, //ユーザー登録データのみ
          use_jobsearch: true, //カエドキ利用事業所のみ
        };
        this.postJsonCheck(
          window.base_url + "/api/admin/portal_offices/get",
          searchObj,
          (res) => {
            this.offices = res.data.all_portal_offices ?? [];
            resolve(res);
          }
        );
      }),
      new Promise((resolve) => {
        this.postJsonCheck(
          window.base_url + "/api/admin/portal_jobsearch_recruitees/get",
          {},
          (res) => {
            this.recruitees = res.data.recruitees ?? [];
            resolve(res);
          }
        );
      }),
    ]);
  }

  /** 保存ボタンクリック時 */
  private async save(item: PortalOfficialAnnouncement) {
    const announcementForm: PortalOfficialAnnouncementForm = {
      target_portal_office_ids: [],
      target_organization_ids: [],
      target_recruitee_ids: [],
      ...item,
    };

    if (announcementForm.announced_at == " :") {
      announcementForm.announced_at = "";
    }

    let isDisplayTermEmpty = false;
    if (announcementForm.display_start_at == " :") {
      this.announcement.display_start_at = "";
      isDisplayTermEmpty = true;
    }
    if (announcementForm.display_end_at == " :") {
      this.announcement.display_end_at = "";
      isDisplayTermEmpty = true;
    }

    if (!this.inputForm.validate() || isDisplayTermEmpty) {
      await this.$openAlert("入力内容に不備があります。");
      return;
    }
    if (!(await this.$openConfirm("保存しますか？"))) {
      return;
    }

    if (
      announcementForm.destination != null &&
      [6, 7].includes(announcementForm.destination)
    ) {
      if (announcementForm.has_target) {
        if (this.targetOffices.length || this.targetRecruitees.length) {
          announcementForm.target_portal_office_ids = this.targetOffices.map(
            (i) => i.id
          ) as number[] | null;
          announcementForm.target_recruitee_ids = this.targetRecruitees.map(
            (i) => i.id
          ) as number[] | null;
        } else {
          const destText =
            PORTAL_JOBSEARCH_OFFICIAL_ANNOUNCEMENT_DESTINATION.find(
              (i) => i.value === announcementForm.destination
            )?.text;
          if (
            !(await this.$openConfirm(
              `事業所が選択されていないため、${destText}全てへのお知らせになります。よろしいですか？`
            ))
          )
            return;

          announcementForm.has_target = false;
          announcementForm.target_portal_office_ids = [];
          announcementForm.target_recruitee_ids = [];
        }
      } else {
        announcementForm.target_portal_office_ids = [];
        announcementForm.target_recruitee_ids = [];
      }
    }

    if (
      announcementForm.destination != null &&
      [8, 9, 10].includes(announcementForm.destination)
    ) {
      announcementForm.has_target = false;
      announcementForm.target_portal_office_ids = [];
      announcementForm.target_recruitee_ids = [];
    }
    if (announcementForm.destination == 9) {
      announcementForm.is_mail_on = false;
    }

    // 配信完了以外
    if (announcementForm.status != 3) {
      announcementForm.status = 2; // 配信予約済み
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/portal_official_announcement/save",
      {
        service: 1,
        official_announcement: announcementForm,
      },
      (res) => {
        this.announcement = res.data.official_announcement;
        this.showSaveCompleteBar = true;
        this.$router.push({ path: `/jobsearch-announcement/list` });
      }
    );
  }

  // キャンセルボタンクリック
  private async cancel() {
    if (
      await this.$openConfirm(
        "編集を終了します\n編集中の場合は内容が破棄されます"
      )
    ) {
      this.$router.push({ path: `/jobsearch-announcement/list` });
    }
  }

  /** 全体 <-> 選択の切り替え時 */
  private changeTarget() {
    this.targetOffices = [];
    this.targetRecruitees = [];
    this.announcement.has_target = false;
  }
}
